// Module
var code = "<div class=dashWrapper> <secondary-nav class=inbox-version active=inbox></secondary-nav><div><personal-inbox ng-if=$ctrl.canInit role={{$ctrl.role}} component-is-ready=$ctrl.componentIsReady() set-seo=$ctrl.setSeo(numRequests)></personal-inbox></div></div>";
// Exports
module.exports = code;